/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Money_Art_NoteInputs */

const en_services_svc_money_art_note = /** @type {(inputs: Services_Svc_Money_Art_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Illustrative lead run, drawn from the lead radar we run.`)
};

const lv_services_svc_money_art_note = /** @type {(inputs: Services_Svc_Money_Art_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilustratīvs piemērs no mūsu potenciālo klientu radara.`)
};

/**
* | output |
* | --- |
* | "Illustrative lead run, drawn from the lead radar we run." |
*
* @param {Services_Svc_Money_Art_NoteInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_money_art_note = /** @type {((inputs?: Services_Svc_Money_Art_NoteInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Money_Art_NoteInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_money_art_note(inputs)
	return en_services_svc_money_art_note(inputs)
});